import { Popover, CircularProgress } from '@material-ui/core';
import { TAiAverageItem } from '../../../types/estimate/estimate';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { useEffect, useState } from 'react';

type AiPriceProps = {
  showAiPricePopup: boolean;
  priceAnchorEl: HTMLElement | null;
  averagePriceList: TAiAverageItem;
  isAiPriceLoading: boolean;
  handleAiPricePopupClose: () => void;
};
export const AiPricePopup: React.FC<AiPriceProps> = (props: AiPriceProps) => {
  const {
    showAiPricePopup,
    priceAnchorEl,
    averagePriceList,
    isAiPriceLoading,
    handleAiPricePopupClose
  } = props;
  const [validAveragePrice, setValidAveragePrice] = useState<string>('');

  useEffect(() => {
    if (typeof averagePriceList['average_price'] === 'number') {
      setValidAveragePrice(
        (
          Math.round(averagePriceList['average_price'] / 10) * 10
        ).toLocaleString()
      );
    }
  }, [averagePriceList]);

  return (
    <div>
      <div>
        <Popover
          open={showAiPricePopup}
          anchorEl={priceAnchorEl}
          onClose={handleAiPricePopupClose}
          elevation={1}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          disableEnforceFocus
          disableAutoFocus
        >
          {isAiPriceLoading ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <IconButton aria-label='close' onClick={handleAiPricePopupClose}>
                <CloseIcon fontSize='small' />
              </IconButton>
              {isAiPriceLoading && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <CircularProgress />
                </div>
              )}
            </div>
          ) : (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'start'
              }}
            >
              <div style={{ padding: '16px 24px' }}>
                入力中のカテゴリ
                <br />"{averagePriceList['estimate_item_cat']}"<br />"
                {averagePriceList['estimate_sub_cat']}"<br />
                {typeof averagePriceList['average_price'] === 'string'
                  ? `参照するデータがありません。`
                  : `の単価平均は${validAveragePrice}円です。`}
              </div>
              <div>
                <IconButton
                  aria-label='close'
                  onClick={handleAiPricePopupClose}
                >
                  <CloseIcon fontSize='small' />
                </IconButton>
              </div>
            </div>
          )}
        </Popover>
      </div>
    </div>
  );
};
